import { DashboardTranslate } from './dashboardTranslate.model';

const dashboardTranslatePTBR: DashboardTranslate = {
  title: 'Visão geral',
  kpi: {
    eventsThisWeek: {
      label: 'Eventos esta semana',
      subtext: 'Próximo: {{name}}',
      empty: 'Nenhum evento agendado',
    },
    newLeadsThisMonth: {
      label: 'Leads novos no mês',
      subtext: '{{delta}} vs mês anterior',
    },
    overdueTasks: {
      label: 'Tarefas atrasadas',
      subtext: 'Toque para ver',
    },
    overdueAmount: {
      label: 'Em atraso',
      subtext_one: '{{count}} cliente para cobrar',
      subtext_other: '{{count}} clientes para cobrar',
      empty: 'Nada em atraso',
    },
    dueTodayTasks: {
      label: 'Vencem hoje',
      subtext: 'Toque para ver',
    },
  },
  widgets: {
    receivables: 'Cobranças',
    todos: 'Tarefas',
    events: 'Próximos eventos',
    leads: 'Clientes recentes',
    births: 'Partos previstos',
  },
  customize: {
    trigger: 'Personalizar',
    title: 'Widgets visíveis',
  },
  upcomingBirths: {
    title: 'Nascimentos previstos',
    today: 'hoje',
    inDays: 'em {{count}} dia(s)',
    overdueDays: 'atrasado {{count}} dia(s)',
  },
};

export default dashboardTranslatePTBR;
